export enum InvoiceHistoricalActionEnum {
	CreateFileAdded = 1,
	EditFileAdded = 2,
	EditFileRemoved = 3,
}
